import { QRFC } from "./QRFC";

export class QActivityReportRFC extends QRFC {
  constructor() {
    super();
  }

  InitActivityReportRFC(callbackObj) {
    this.fWSMgr = callbackObj.fWSMgr;
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, userName, data) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
    this.AddParameter("data", data);
    this.AddParameter("mode", "activityReportDump");
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    if (success) {
      var filename = r["filename"];
      callBackObj.ExcelDBResult(success, filename);
    }
  }
}
